import { render, staticRenderFns } from "./InternalServerError.vue?vue&type=template&id=18be00f8&scoped=true"
import script from "./InternalServerError.vue?vue&type=script&lang=ts"
export * from "./InternalServerError.vue?vue&type=script&lang=ts"
import style0 from "./InternalServerError.vue?vue&type=style&index=0&id=18be00f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be00f8",
  null
  
)

export default component.exports